import React from 'react';
import { Button } from '@/components/ui/button';
import { IconProvider } from '@/components/ui';
import { FormNavigationProps } from './FormWizardTypes';

/**
 * FormNavigation - Navigation controls for the form wizard
 * Provides Back, Next, and Submit buttons
 */
export function FormNavigation({
  showBack,
  showNext,
  showSubmit,
  backDisabled = false,
  nextDisabled = false,
  submitDisabled = false,
  onBack,
  onNext,
  onSubmit,
  isSubmitting = false,
}: FormNavigationProps) {
  return (
    <div className="flex items-center justify-between w-full mt-8">
      {/* Back Button */}
      <div className="flex-1">
        {showBack && (
          <Button
            onClick={onBack}
            disabled={backDisabled}
            variant="ghost"
            size="lg"
            className="group"
          >
            <IconProvider 
              iconstring="fa-arrow-left" 
              className="mr-2 h-4 w-4 group-hover:-translate-x-1 transition-transform" 
            />
            Back
          </Button>
        )}
      </div>

      {/* Next/Submit Button */}
      <div className="flex-1 flex justify-end">
        {showNext && (
          <Button
            onClick={onNext}
            disabled={nextDisabled}
            variant="default"
            size="lg"
            className="group min-w-[120px]"
          >
            Next
            <IconProvider 
              iconstring="fa-arrow-right" 
              className="ml-2 h-4 w-4 group-hover:translate-x-1 transition-transform" 
            />
          </Button>
        )}

        {showSubmit && (
          <Button
            onClick={onSubmit}
            disabled={submitDisabled || isSubmitting}
            variant="default"
            size="lg"
            className="min-w-[120px] bg-green-600 hover:bg-green-700"
          >
            {isSubmitting ? (
              <>
                <IconProvider iconstring="fa-spinner" className="mr-2 h-4 w-4 animate-spin" />
                Creating...
              </>
            ) : (
              <>
                <IconProvider iconstring="fa-check" className="mr-2 h-4 w-4" />
                Create
              </>
            )}
          </Button>
        )}
      </div>
    </div>
  );
}
